import {DataGrid} from "@mui/x-data-grid";
import { Paper, Typography, Button, TextField, FormControl, FormGroup, InputLabel, Select, MenuItem} from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles';
import GetRole from "./user";
import {useEffect, useState} from "react"
import {CSVLink} from "react-csv"
import { fetchCandidatesbycreateddate, fetchEmployees, fetchCandidatesbyscheduleddate, fetchCandidatesbynumber } from "../api/customerapi";
import DateCalc, {calculateAveragewithoutzero, calculateAverage, DateCalc2, removeDuplicates, getmonth, countTextValues, getconvdatearray, getprofit, gethotdatearray} from "./date";
import { useAppData } from "./appDataContext.js";

const useStyles = makeStyles((theme) => ({
    paper: {
      marginLeft: theme.spacing(10),
      marginRight: theme.spacing(10),
      marginBottom: theme.spacing(5),
      marginTop: theme.spacing(4),
      justifyContent: "center",
      backgroundColor: "#f8f8f8"
    },
    headertext: {
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
  },
  textField: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(60),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
    },
  
    button: {
      marginLeft: theme.spacing(1),
      marginRight: theme.spacing(4),
      width: theme.spacing(40),
      height: theme.spacing(6),
      marginTop: theme.spacing(2),
      marginBottom: theme.spacing(2),
      justifyContent: "center",
    },
}));

const Listhrdata = () => {

const classes = useStyles();
const width = window.innerWidth-200;
const { appData, loading } = useAppData();
var {cuser, role}=GetRole();
const columns = [
    { field: 'candidate_id', 
  headerName: 'Candidate ID', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
    { field: 'candidate_name', 
    headerName: 'Name', 
    width: width/12,
    cellClassName: "gridcell"
    //align:"center",
    //headerAlign:"center"
    },
    {
      field: 'candidate_contact',
      headerName: 'Contact',
      width: width/12,
      
    },
    {
      field: 'source',
      headerName: 'Source',
      width: width/12,
    },
    {
      field: 'position',
      headerName: 'Position',
      width: width/12,
    },
    {
      field: 'hr',
      headerName: 'HR',
      width: width/12,
    },
    {
      field: 'status',
      headerName: 'Status',
      width: width/12,
    },
    {
      field: 'last_round_name',
      headerName: 'Last Round',
      width: width/12,
    },
    {
      field: 'last_round_status',
      headerName: 'Last Status',
      width: width/12,
    },
    {
      field: 'last_round_date',
      headerName: 'Round Date',
      width: width/12,
    },
    
  ];

  const columns2 = [
  { field: 'hr', 
  headerName: 'HR', 
  width: width/12,
  cellClassName: "gridcell"
  //align:"center",
  //headerAlign:"center"
},
{ field: 'called', 
  headerName: 'Called Today', 
  width: width/12,
  cellClassName: "gridcell"
 
},
{ field: 'interview1', 
  headerName: 'Interview D+0', 
  width: width/12,
  cellClassName: "gridcell"
 
},
{ field: 'interview2', 
  headerName: 'Interview D+1', 
  width: width/12,
  cellClassName: "gridcell"
 
},
{ field: 'interview3', 
  headerName: 'Interview D+2', 
  width: width/12,
  cellClassName: "gridcell"
 
},
  
];

   const [listcandidateData, setlistcandidateData] =useState([]);
    const [listcandidateData2, setlistcandidateData2] =useState([]);
     const [listcandidateData3, setlistcandidateData3] =useState([]);
      const [listcandidateData4, setlistcandidateData4] =useState([]);
       const [listcandidateData5, setlistcandidateData5] =useState([]);

   const [eData, seteData] =useState([]);
   const [hremp, sethremp] =useState([]);
   const [filterData, setfilterData] =useState(null);
  
   const getEmployees = async () => {
    try{
    const data = await fetchEmployees();
    sethremp(data.data.filter(emp => emp.role=="HR"))
    seteData(data.data.filter(emp => emp.role=="Admin" || emp.role=="TL" || emp.role=="Support" || emp.role=="Manager" || emp.role=="Product" || emp.role=="Operations-TL" || emp.role=="Marketing"))
}catch(err){
    console.log(err)
  }
}

useEffect(() => {
        getCandidatesbydate(DateCalc(0), DateCalc(1))
        getCandidatesbyScheduleddate2()
    
        getEmployees()
    }, [cuser])

const getCandidates = async () => {
  try{
    if(filterData && filterData.start_date,  filterData.end_date){
  const data = await fetchCandidatesbycreateddate(filterData.start_date, filterData.end_date);
  //const custdatalistfromdb= data.data
  setlistcandidateData(data.data)
    }else{
      alert("Enter dates and try again")
    }
}catch(err){
  console.log(err)
}
}

const getCandidatesbydate = async (start, end) => {
  try{
    if(start && end){
  const data = await fetchCandidatesbycreateddate(start, end);
  //const custdatalistfromdb= data.data
  setlistcandidateData2(data.data)
    }else{
      alert("Enter dates and try again")
    }
}catch(err){
  console.log(err)
}
}

const getCandidatesbyScheduleddate2 = async () => {
  try{
      const data = await fetchCandidatesbyscheduleddate(DateCalc(0), DateCalc(1));
 console.log(data.data)
const temp10=data.data.filter(data=>"rounds" in data && !(data.rounds.round_name=="CV Selection" || data.rounds.round_name=="First Call Round") )
 const temp=removeDuplicates(temp10, "candidate_id")

  setlistcandidateData3(temp)
   const data2 = await fetchCandidatesbyscheduleddate(DateCalc(1), DateCalc(2));
  const temp20=data2.data.filter(data=>"rounds" in data && !(data.rounds.round_name=="CV Selection" || data.rounds.round_name=="First Call Round") )
    const temp2=removeDuplicates(temp20, "candidate_id")
  setlistcandidateData4(temp2)
    const data3 = await fetchCandidatesbyscheduleddate(DateCalc(2), DateCalc(3));
    const temp30=data3.data.filter(data=>"rounds" in data && !(data.rounds.round_name=="CV Selection" || data.rounds.round_name=="First Call Round") )
     const temp3=removeDuplicates(temp30, "candidate_id")
  setlistcandidateData5(temp3)
}catch(err){
  console.log(err)
}
}

const getCandidatesbyScheduleddate = async () => {
  try{
    if(filterData && filterData.start_date &&  filterData.end_date){
  const data = await fetchCandidatesbyscheduleddate(filterData.start_date, filterData.end_date);
 console.log(data.data)
 const temp10=data.data.filter(data=>"rounds" in data && !(data.rounds.round_name=="CV Selection" || data.rounds.round_name=="First Call Round") )
 const temp=removeDuplicates(temp10, "candidate_id")
  setlistcandidateData(temp)
    }else{
      alert("Enter dates and try again")
    }
}catch(err){
  console.log(err)
}
}

const getCandidatesbynumber = async () => {
  try{
    if(filterData && filterData.contact){
  const data = await fetchCandidatesbynumber(filterData.contact);
 console.log(data.data)
 
  setlistcandidateData(data.data)
    }else{
      alert("Enter dates and try again")
    }
}catch(err){
  console.log(err)
}
}

var finarr=[]
if(listcandidateData2.length>0){
  
  for(let i=0;i<hremp.length;i++){
    const total=listcandidateData2.filter(c=>c.hr_name==hremp[i].short_name)
    const d0=listcandidateData3.filter(c=>c.hr_name==hremp[i].short_name)
    const d1=listcandidateData4.filter(c=>c.hr_name==hremp[i].short_name)
    const d2=listcandidateData5.filter(c=>c.hr_name==hremp[i].short_name)
    var temp={
      hr:hremp[i].short_name,
      called:total.length,
      interview1:d0.length,
      interview2:d1.length,
      interview3:d2.length,
    }
    finarr=[...finarr, temp]
  }
  var total={
    hr:"Total",
    called:listcandidateData2.length,
    interview1:listcandidateData3.length,
    interview2:listcandidateData4.length,
    interview3:listcandidateData5.length,
  }
  finarr=[...finarr, total]
}

  const custdatalistdisplay=finarr.map(data=>(
    {hr: data.hr, 
  id:finarr.indexOf(data), 
  called:data.called, 
 interview1:data.interview1, 
  interview2:data.interview2, 
  interview3:data.interview3, 
}));
  

  
  useEffect(() => {
    getEmployees()
    
  }, [])

  var l1=[...listcandidateData]
  
  if(filterData){
    if(filterData.position){
      l1=l1.filter(c=>c.position==filterData.position)
    }
    if(filterData.hr){
      l1=l1.filter(c=>c.hr_name==filterData.hr)
    }
    if(filterData.status){
      l1=l1.filter(c=>c.final_status==filterData.status)
    }
  }
  
  
  const candidatedatalistdisplay=l1.map(employeedata=>({candidate_name: employeedata.name, 
    id:l1.indexOf(employeedata),
    candidate_id:employeedata.candidate_id, 
    position:employeedata.position,
    hr:employeedata.hr_name,
    status:employeedata.final_status,
    candidate_contact:employeedata.contact, 
    source:employeedata.source,
    last_round_name:"rounds" in employeedata && employeedata.rounds.length>0?employeedata.rounds[employeedata.rounds.length-1].round_name:"",
    last_round_status:"rounds" in employeedata && employeedata.rounds.length>0?employeedata.rounds[employeedata.rounds.length-1].round_result:"",
    last_round_date:"rounds" in employeedata && employeedata.rounds.length>0?employeedata.rounds[employeedata.rounds.length-1].round_date:"",
    }));

  
  //console.log(custdatalistfromdb);

  const gridcelldoubleclick=(id)=>{
    //window.location = ("/employeedataentry/"+id);
    window.open("/canddataentry/"+id, "_blank");
    //console.log("/custdataentry/"+id);
  }



    return ( 
      <div>
      <Paper variant="outlined" className={classes.paper}>
      <div align="center">
        <Typography variant="h4" align="center" className={classes.headertext}>HR Summary</Typography>
        
        </div>
        <div style={{ height: 600, width: '100%' }}>
      <DataGrid rows={custdatalistdisplay} 
        
        columns={columns2}
        // pageSize={20}
        autoPageSize
        // autoHeight
        >      
      </DataGrid>      
    </div>
      </Paper>
        <Paper variant="outlined" className={classes.paper}> 
        <div align="center">
        <Typography variant="h4" align="center" className={classes.headertext}> View Candidates</Typography>
       
        <Button href="/canddataentry"  variant="contained" color="primary" align="center" className={classes.button}>Add Candidate</Button>
       
        </div>
        <div align="center">
          <TextField
            variant="outlined"
            type="date"
            label="Created On or after"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setfilterData({ ...filterData, start_date: e.target.value })
            }
          />

          <TextField
            variant="outlined"
            type="date"
            label="Created On or before"
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            onChange={(e) =>
              setfilterData({ ...filterData, end_date: e.target.value })
            }
          />

          
          <Button
            onClick={getCandidates}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search by created
          </Button>
          <Button
            onClick={getCandidatesbyScheduleddate}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search by scheduled
          </Button>
          <Button
            onClick={getCandidatesbynumber}
            color="secondary"
            variant="contained"
            className={classes.button}
          >
            Search by number
          </Button>
          </div>
        <FormGroup row className={classes.formgroup}>
        <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Status">Final Status</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Status"  onChange={(e)=> setfilterData({...filterData, status: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"Deployed"}>Deployed</MenuItem>
                    <MenuItem value={"Joined"}>Joined</MenuItem>
                    <MenuItem value={"Selected"}>Selected</MenuItem>
                    <MenuItem value={"Did not join"}>Did not join</MenuItem>
                    <MenuItem value={"Rejected"}>Rejected</MenuItem>
                    <MenuItem value={"Declined"}>Declined</MenuItem>
                    <MenuItem value={"Awaiting Task"}>Awaiting Task</MenuItem>
                    <MenuItem value={"In Process"}>In Process</MenuItem>
                    <MenuItem value={"Open"}>Open</MenuItem>
                    
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="HR">HR</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Manager"  onChange={(e)=> setfilterData({...filterData, hr: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                    {eData.map(emp => {
                    return <MenuItem value={emp.short_name}>{emp.name}</MenuItem>})}
                    
                </Select>
                </FormControl>
                <FormControl style={{minWidth: 240, marginTop: 16, marginRight: 20, marginLeft: 8}}>
            <InputLabel id="Position">Position</InputLabel>
                <Select displayEmpty className={classes.textField} labelId="Position"  onChange={(e)=> setfilterData({...filterData, position: e.target.value})}>
                <MenuItem value={""}>Clear</MenuItem>
                <MenuItem value={"L1-Sales"}>L1-Sales</MenuItem>
                    <MenuItem value={"L2-Sales"}>L2-Sales</MenuItem>
                    <MenuItem value={"L3-Sales"}>L3-Sales</MenuItem>
                    <MenuItem value={"L4-Sales"}>L4-Sales</MenuItem>
                    <MenuItem value={"L1-Operations"}>L1-Operations</MenuItem>
                    <MenuItem value={"L2-Operations"}>L2-Operations</MenuItem>
                    <MenuItem value={"L3-Operations"}>L3-Operations</MenuItem>
                    <MenuItem value={"L4-Operations"}>L4-Operations</MenuItem>
                    <MenuItem value={"L1-Marketing"}>L1-Marketing</MenuItem>
                    <MenuItem value={"L2-Marketing"}>L2-Marketing</MenuItem>
                    <MenuItem value={"L3-Marketing"}>L3-Marketing</MenuItem>
                    <MenuItem value={"L4-Marketing"}>L4-Marketing</MenuItem>
                    <MenuItem value={"L1-Accounts"}>L1-Accounts</MenuItem>
                    <MenuItem value={"L2-Accounts"}>L2-Accounts</MenuItem>
                    <MenuItem value={"L3-Accounts"}>L3-Accounts</MenuItem>
                    <MenuItem value={"L4-Accounts"}>L4-Accounts</MenuItem>
                    <MenuItem value={"L1-Product"}>L1-Product</MenuItem>
                    <MenuItem value={"L2-Product"}>L2-Product</MenuItem>
                    <MenuItem value={"L3-Product"}>L3-Product</MenuItem>
                    <MenuItem value={"L4-Product"}>L4-Product</MenuItem>
                    <MenuItem value={"L1-HR & Admin"}>L1-HR & Admin</MenuItem>
                    <MenuItem value={"L2-HR & Admin"}>L2-HR & Admin</MenuItem>
                    <MenuItem value={"L3-HR & Admin"}>L3-HR & Admin</MenuItem>
                    <MenuItem value={"L4-HR & Admin"}>L4-HR & Admin</MenuItem>
                    <MenuItem value={"L1-Tech"}>L1-Tech</MenuItem>
                    <MenuItem value={"L2-Tech"}>L2-Tech</MenuItem>
                    <MenuItem value={"L3-Tech"}>L3-Tech</MenuItem>
                    <MenuItem value={"L4-Tech"}>L4-Tech</MenuItem>
                    <MenuItem value={"L5"}>L5</MenuItem>
                    <MenuItem value={"L6"}>L6</MenuItem>
                    <MenuItem value={"L7"}>L7</MenuItem>
                    
                </Select>
                </FormControl>
                <TextField
      
            variant="standard"
            type="date"
            label={"Contact"}
        
           
            InputLabelProps={{ shrink: true }}
           
            className={classes.textField3}
           
            onChange={(e) =>
              setfilterData({ ...filterData, contact: e.target.value })
            }
          />
        </FormGroup>
        {candidatedatalistdisplay.length>0?(
        <div style={{ height: 1200, width: '100%' }}>
      <DataGrid rows={candidatedatalistdisplay} 
        onCellDoubleClick={(getValue)=>gridcelldoubleclick(getValue.row.candidate_id)}
        columns={columns}
        autoPageSize
        // pageSize={20}
        // rowHeight={50}
       
        // autoHeight
        >      
      </DataGrid>      
    </div>
  ):("")}
    </Paper>
       
        </div>
     )
}
 
export default Listhrdata;

